

















































































import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'
import Component from 'vue-class-component'

import { FacilityModule } from '@/store/modules/facility.module'
import { EUserPermissions, EUserStatus, IFacility, IFacilityCollectionSettings, IUser } from '@zunta/configurations'
import Card from '@/components/Card.vue'
import { User } from '@/classes/User'
import Api from '@/api'
import InputV2 from '@/components/inputsV2/InputV2.vue'
import SelectV2 from '@/components/inputsV2/SelectV2.vue'
import { integer, minValue, required } from 'vuelidate/lib/validators'
import InputValidator from '@/components/inputsV2/InputValidator.vue'
import LoaderWrapper from '@/components/layout/LoaderWrapper.vue'
import { UserModule } from '@/store/modules/user.module'

const range = require('lodash.range')

@Component({
  name: 'GeneralCollectionsSettings',
  components: {
    LoaderWrapper,
    InputValidator,
    SelectV2,
    InputV2,
    Card
  }
})
export default class GeneralCollectionsSettings extends Vue {
  facilityModuleInstance: FacilityModule = getModule(FacilityModule, this.$store)
  userModuleInstance: UserModule = getModule(UserModule, this.$store)
  EUserPermissions: any = EUserPermissions
  user: User = Api.getUser() as User

  data: Partial<IFacilityCollectionSettings> = {
    attemptContactResidentEvery: undefined,
    escalateCollectionAfter: undefined,
    newCollectionsUser: undefined,
    escalatedIssuesUser: undefined
  }

  isLoading: boolean = false

  validations (): any {
    return {
      data: {
        attemptContactResidentEvery: {
          required,
          positive: minValue(1),
          integer
        },
        newCollectionsUser: {
          required
        },
        escalateCollectionAfter: {
          required,
          positive: minValue(1),
          integer
        },
        escalatedIssuesUser: {
          required
        }
      }
    }
  }

  get facilityManagersList () {
    return this.$store.state.user.users
  }

  get facilityId () {
    return this.$route.params.id
  }

  get facilityCollectionSettings () {
    return this.$store.state.facility.facilityCollectionSettings
  }

  get managersItemsList (): IUser[] {
    return this.facilityManagersList.reduce((managers: IUser[], manager: IUser) => {
      if (manager.isAllFacilities || (manager.facilities && manager.facilities.some(el => el.toString() === this.facilityId.toString()))) {
        return [...managers, {
          key: manager.id,
          value: manager.id,
          content: `${manager.firstName} ${manager.lastName}`
        }]
      }

      return managers
    }, []) || [] as IUser[]
  }

  get selectedFacility (): IFacility {
    return this.$store.state.facility.selectedFacility
  }

  async mounted () {
    await this.facilityModuleInstance.getFacilityCollectionSettings(this.facilityId)
    await this.userModuleInstance.getManagementUsersList({ status: EUserStatus.ACTIVE })
    if (this.facilityCollectionSettings) {
      this.data.attemptContactResidentEvery = this.facilityCollectionSettings.attemptContactResidentEvery
      this.data.escalateCollectionAfter = this.facilityCollectionSettings.escalateCollectionAfter
      this.data.newCollectionsUser = this.facilityCollectionSettings.newCollectionsUser
      this.data.escalatedIssuesUser = this.facilityCollectionSettings.escalatedIssuesUser
      // this.data.reviewLettersUser = this.facilityCollectionSettings.reviewLettersUser
    }
  }

  async submit () {
    this.$v.$touch()
    if (this.$v.$anyError) {
      return
    }

    try {
      this.isLoading = true
      await this.facilityModuleInstance.updateFacilityCollectionSettings({
        facilityId: this.facilityId,
        data: this.data
      })
      this.$eventBus.$emit('notify', {
        color: 'var(--status-success-color)',
        message: '',
        header: 'Success',
        icon: 'check'
      })
    } finally {
      this.isLoading = false
    }
  }
}
